import { EXPERIMENTS, ROLLOUTS } from '@fiverr-private/listing_experiments';
import { EXPERIMENT_TYPE } from '@fiverr-private/experiments';
import { RequestContext } from '@fiverr-private/perseus';
import { isActive } from '@fiverr-private/rollout_js';
import { LEAF_IDS, SELLER_COUNTRIES } from './bookPublishing.constants';

export const isEligibleForBookPublishingExperience = (leafId: number) => LEAF_IDS.includes(leafId);

export const isBookPublishingAllocationGuardActive = async () => {
    const { userId } = RequestContext;

    if (!userId) {
        return false;
    }

    return await isActive(ROLLOUTS.CHEETAHS_BOOK_PUBLISHING_ALLOCATION_GUARD, userId);
};

const isEligibleForBookPublishingAllocation = async () => {
    const { userId, countryCode, initialProps = {}, abTests = {} } = RequestContext;

    if (!userId) {
        return false;
    }

    if (SELLER_COUNTRIES.includes(countryCode)) {
        return false;
    }

    if (EXPERIMENTS.OWLS_GNN_EXP in abTests && abTests[EXPERIMENTS.OWLS_GNN_EXP] !== 1) {
        return false;
    }

    if (!isEligibleForBookPublishingExperience(Number(initialProps.dominateSubCategoryId))) {
        return false;
    }

    if (!(await isBookPublishingAllocationGuardActive())) {
        return false;
    }

    if (!(await isActive(ROLLOUTS.CHEETAHS_BOOK_PUBLISHING, userId))) {
        return false;
    }

    return true;
};

export const bookPublishingExperiment = {
    id: EXPERIMENTS.CHEETAHS_BOOK_PUBLISHING,
    experimentType: EXPERIMENT_TYPE.USER,
    numOfGroups: 2,
    shouldAllocate: isEligibleForBookPublishingAllocation,
};
